import Vue from 'vue';
import IconArrowPrevDark from '@/components/icons/IconArrowPrevDark.vue';
import IconArrowNextDark from '@/components/icons/IconArrowNextDark.vue';
import { mapGetters, mapMutations } from 'vuex';
import { MEDIA } from '@/helpers/variables';
import IconPlayFill from '@/components/icons/IconPlayFill.vue';
import { PRODUCT_SLIDER_ITEM_TYPE } from '@/helpers';
import ImageCard from '@/components/@general/ImageCard/index.vue';
import IconZoomIn from '@/components/icons/IconZoomIn.vue';
export default {
  components: { IconZoomIn, ImageCard, IconPlayFill, IconArrowNextDark, IconArrowPrevDark },
  props: {
    slides: {
      type: Array,
      default: () => []
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  name: 'ProductSlider',
  data() {
    return {
      MEDIA,
      PRODUCT_SLIDER_ITEM_TYPE,
      activeIndex: 0,
      widthItemView: 0,
      heightItemView: 0,
      index: null,
      videoEnded: true
    };
  },
  mounted() {
    Vue.nextTick(() => {
      this.widthItemView = this.$refs.viewContainer.offsetWidth;
      this.heightItemView = this.$refs.viewContainer.offsetHeight;
    });
  },
  watch: {
    'appSize.w': {
      immediate: false,
      handler(newVal) {
        if (newVal) {
          this.widthItemView = this.$refs.viewContainer.offsetWidth;
          this.heightItemView = this.$refs.viewContainer.offsetHeight;
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      appSize: 'app/size'
    })
  },
  methods: {
    ...mapMutations({
      modalOpen: 'app/MODAL_OPEN',
      modalSetData: 'app/MODAL_SET_DATA'
    }),
    changeActiveSlideIndex(index) {
      this.activeIndex = index;
    },
    onChangeSlide(direction) {
      try {
        this.$refs.video[0].pause();
        this.videoEnded = true;
      } catch (e) {}

      if (direction === 'prev') {
        if (this.activeIndex > 0) {
          this.activeIndex--;
        }
      } else if (direction === 'next') {
        if (this.activeIndex < this.slides.length - 1) {
          this.activeIndex++;
        }
      }
    },
    onZoom(index) {
      console.log('onZoom', this.slides);
      this.modalSetData({ key: 'zoomModal', data: { slides: this.slides, data: this.data, activeIndex: index } });
      this.modalOpen('zoomModal');
    },
    onVideoEnded() {
      this.videoEnded = true;
      this.$refs.video[0].pause();
    },
    onVideoPlay() {
      this.videoEnded = false;
    },
    onPlayVideo() {
      this.$refs.video[0].play();
    },
    onPauseVideo() {
      this.$refs.video[0].pause();
      this.videoEnded = true;
    }
  }
};
